import React, { useState } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { formatNumber } from "chart.js/helpers";
import { Pagination } from "antd";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Referral Code",
    dataIndex: "referral_code",
    key: "referral_code",
  },
  {
    title: "Total Owed",
    dataIndex: "total_owed",
    key: "total_owed",
  },
  {
    title: "Average Users LTV",
    dataIndex: "average_users_ltv",
    key: "average_users_ltv",
  },
  {
    title: "Total FTDs",
    dataIndex: "total_ftds",
    key: "total_ftds",
  },
  {
    title: "Average Deposit",
    dataIndex: "average_deposit",
    key: "average_deposit",
  },
];

const data = [
  {
    key: 1,
    id: 1,
    name: "OddsChecker",
    referral_code: "2 Codes",
    total_owed: 3200,
    average_users_ltv: 200,
    total_ftds: 6000,
    average_deposit: 250,
    expandable: true,
    referral_codes: [
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 1",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 2",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
    ],
  },
  {
    key: 2,
    id: 2,
    name: "Action Network",
    referral_code: "2 Codes",
    total_owed: 5000,
    average_users_ltv: 300,
    total_ftds: 8000,
    average_deposit: 350,
    referral_codes: [
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 3",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 4",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
    ],
  },
  {
    key: 3,
    id: 3,
    name: "Barstool Sports",
    referral_code: "CODE789",
    total_owed: 10000,
    average_users_ltv: 500,
    total_ftds: 12000,
    average_deposit: 600,
  },
  {
    key: 4,
    id: 4,
    name: "Ralph Edwards",
    referral_code: "CODE101112",
    total_owed: 15000,
    average_users_ltv: 700,
    total_ftds: 20000,
    average_deposit: 800,
  },
  {
    key: 5,
    id: 5,
    name: "BetQL",
    referral_code: "2 Codes",
    total_owed: 20000,
    average_users_ltv: 1000,
    total_ftds: 25000,
    average_deposit: 1200,
    referral_codes: [
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 5",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 6",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
    ],
  },
  {
    key: 6,
    id: 6,
    name: "Rotoworld",
    referral_code: "CODE161718",
    total_owed: 25000,
    average_users_ltv: 1200,
    total_ftds: 30000,
    average_deposit: 1400,
  },
  {
    key: 7,
    id: 7,
    name: "BETMGM",
    referral_code: "CODE192021",
    total_owed: 30000,
    average_users_ltv: 1500,
    total_ftds: 35000,
    average_deposit: 160,
  },
  {
    key: 8,
    id: 8,
    name: "BED365",
    referral_code: "CODE222324",
    total_owed: 35000,
    average_users_ltv: 1700,
    total_ftds: 40000,
    average_deposit: 180,
  },
  {
    key: 9,
    id: 9,
    name: "BETFRED",
    referral_code: "CODE252627",
    total_owed: 40000,
    average_users_ltv: 2000,
    total_ftds: 45000,
    average_deposit: 200,
  },
  {
    key: 10,
    id: 10,
    name: "BETFAIR",
    referral_code: "CODE282930",
    total_owed: 45000,
    average_users_ltv: 2200,
    total_ftds: 50000,
    average_deposit: 220,
  },
  {
    key: 11,
    id: 11,
    name: "BETWAY",
    referral_code: "CODE313233",
    total_owed: 50000,
    average_users_ltv: 2500,
    total_ftds: 55000,
    average_deposit: 240,
  },
  {
    key: 12,
    id: 12,
    name: "BETVICTOR",
    referral_code: "CODE343536",
    total_owed: 55000,
    average_users_ltv: 2700,
    total_ftds: 60000,
    average_deposit: 260,
  },
  {
    key: 13,
    id: 13,
    name: "BETFAIR2",
    referral_code: "CODE373839",
    total_owed: 60000,
    average_users_ltv: 3000,
    total_ftds: 65000,
    average_deposit: 280,
  },
  {
    key: 14,
    id: 14,
    name: "BettingPros",
    referral_code: "CODE404142",
    total_owed: 65000,
    average_users_ltv: 3200,
    total_ftds: 70000,
    average_deposit: 300,
  },
  {
    key: 15,
    id: 15,
    name: "Arlene McCoy",
    referral_code: "CODE434445",
    total_owed: 70000,
    average_users_ltv: 3500,
    total_ftds: 75000,
    average_deposit: 320,
  },
  {
    key: 1,
    id: 1,
    name: "OddsChecker",
    referral_code: "2 Codes",
    total_owed: 3200,
    average_users_ltv: 200,
    total_ftds: 6000,
    average_deposit: 250,
    expandable: true,
    referral_codes: [
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 1",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 2",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
    ],
  },
  {
    key: 2,
    id: 2,
    name: "Action Network",
    referral_code: "2 Codes",
    total_owed: 5000,
    average_users_ltv: 300,
    total_ftds: 8000,
    average_deposit: 350,
    referral_codes: [
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 3",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 4",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
    ],
  },
  {
    key: 3,
    id: 3,
    name: "Barstool Sports",
    referral_code: "CODE789",
    total_owed: 10000,
    average_users_ltv: 500,
    total_ftds: 12000,
    average_deposit: 600,
  },
  {
    key: 4,
    id: 4,
    name: "Ralph Edwards",
    referral_code: "CODE101112",
    total_owed: 15000,
    average_users_ltv: 700,
    total_ftds: 20000,
    average_deposit: 800,
  },
  {
    key: 5,
    id: 5,
    name: "BetQL",
    referral_code: "2 Codes",
    total_owed: 20000,
    average_users_ltv: 1000,
    total_ftds: 25000,
    average_deposit: 1200,
    referral_codes: [
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 5",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 6",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
    ],
  },
  {
    key: 6,
    id: 6,
    name: "Rotoworld",
    referral_code: "CODE161718",
    total_owed: 25000,
    average_users_ltv: 1200,
    total_ftds: 30000,
    average_deposit: 1400,
  },
  {
    key: 7,
    id: 7,
    name: "BETMGM",
    referral_code: "CODE192021",
    total_owed: 30000,
    average_users_ltv: 1500,
    total_ftds: 35000,
    average_deposit: 160,
  },
  {
    key: 8,
    id: 8,
    name: "BED365",
    referral_code: "CODE222324",
    total_owed: 35000,
    average_users_ltv: 1700,
    total_ftds: 40000,
    average_deposit: 180,
  },
  {
    key: 9,
    id: 9,
    name: "BETFRED",
    referral_code: "CODE252627",
    total_owed: 40000,
    average_users_ltv: 2000,
    total_ftds: 45000,
    average_deposit: 200,
  },
  {
    key: 10,
    id: 10,
    name: "BETFAIR",
    referral_code: "CODE282930",
    total_owed: 45000,
    average_users_ltv: 2200,
    total_ftds: 50000,
    average_deposit: 220,
  },
  {
    key: 11,
    id: 11,
    name: "BETWAY",
    referral_code: "CODE313233",
    total_owed: 50000,
    average_users_ltv: 2500,
    total_ftds: 55000,
    average_deposit: 240,
  },
  {
    key: 12,
    id: 12,
    name: "BETVICTOR",
    referral_code: "CODE343536",
    total_owed: 55000,
    average_users_ltv: 2700,
    total_ftds: 60000,
    average_deposit: 260,
  },
  {
    key: 13,
    id: 13,
    name: "BETFAIR2",
    referral_code: "CODE373839",
    total_owed: 60000,
    average_users_ltv: 3000,
    total_ftds: 65000,
    average_deposit: 280,
  },
  {
    key: 14,
    id: 14,
    name: "BettingPros",
    referral_code: "CODE404142",
    total_owed: 65000,
    average_users_ltv: 3200,
    total_ftds: 70000,
    average_deposit: 300,
  },
  {
    key: 15,
    id: 15,
    name: "Arlene McCoy",
    referral_code: "CODE434445",
    total_owed: 70000,
    average_users_ltv: 3500,
    total_ftds: 75000,
    average_deposit: 320,
  },
  {
    key: 1,
    id: 1,
    name: "OddsChecker",
    referral_code: "2 Codes",
    total_owed: 3200,
    average_users_ltv: 200,
    total_ftds: 6000,
    average_deposit: 250,
    expandable: true,
    referral_codes: [
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 1",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 2",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
    ],
  },
  {
    key: 2,
    id: 2,
    name: "Action Network",
    referral_code: "2 Codes",
    total_owed: 5000,
    average_users_ltv: 300,
    total_ftds: 8000,
    average_deposit: 350,
    referral_codes: [
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 3",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 4",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
    ],
  },
  {
    key: 3,
    id: 3,
    name: "Barstool Sports",
    referral_code: "CODE789",
    total_owed: 10000,
    average_users_ltv: 500,
    total_ftds: 12000,
    average_deposit: 600,
  },
  {
    key: 4,
    id: 4,
    name: "Ralph Edwards",
    referral_code: "CODE101112",
    total_owed: 15000,
    average_users_ltv: 700,
    total_ftds: 20000,
    average_deposit: 800,
  },
  {
    key: 5,
    id: 5,
    name: "BetQL",
    referral_code: "2 Codes",
    total_owed: 20000,
    average_users_ltv: 1000,
    total_ftds: 25000,
    average_deposit: 1200,
    referral_codes: [
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 5",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 6",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
    ],
  },
  {
    key: 6,
    id: 6,
    name: "Rotoworld",
    referral_code: "CODE161718",
    total_owed: 25000,
    average_users_ltv: 1200,
    total_ftds: 30000,
    average_deposit: 1400,
  },
  {
    key: 7,
    id: 7,
    name: "BETMGM",
    referral_code: "CODE192021",
    total_owed: 30000,
    average_users_ltv: 1500,
    total_ftds: 35000,
    average_deposit: 160,
  },
  {
    key: 8,
    id: 8,
    name: "BED365",
    referral_code: "CODE222324",
    total_owed: 35000,
    average_users_ltv: 1700,
    total_ftds: 40000,
    average_deposit: 180,
  },
  {
    key: 9,
    id: 9,
    name: "BETFRED",
    referral_code: "CODE252627",
    total_owed: 40000,
    average_users_ltv: 2000,
    total_ftds: 45000,
    average_deposit: 200,
  },
  {
    key: 10,
    id: 10,
    name: "BETFAIR",
    referral_code: "CODE282930",
    total_owed: 45000,
    average_users_ltv: 2200,
    total_ftds: 50000,
    average_deposit: 220,
  },
  {
    key: 11,
    id: 11,
    name: "BETWAY",
    referral_code: "CODE313233",
    total_owed: 50000,
    average_users_ltv: 2500,
    total_ftds: 55000,
    average_deposit: 240,
  },
  {
    key: 12,
    id: 12,
    name: "BETVICTOR",
    referral_code: "CODE343536",
    total_owed: 55000,
    average_users_ltv: 2700,
    total_ftds: 60000,
    average_deposit: 260,
  },
  {
    key: 13,
    id: 13,
    name: "BETFAIR2",
    referral_code: "CODE373839",
    total_owed: 60000,
    average_users_ltv: 3000,
    total_ftds: 65000,
    average_deposit: 280,
  },
  {
    key: 14,
    id: 14,
    name: "BettingPros",
    referral_code: "CODE404142",
    total_owed: 65000,
    average_users_ltv: 3200,
    total_ftds: 70000,
    average_deposit: 300,
  },
  {
    key: 15,
    id: 15,
    name: "Arlene McCoy",
    referral_code: "CODE434445",
    total_owed: 70000,
    average_users_ltv: 3500,
    total_ftds: 75000,
    average_deposit: 320,
  },
  {
    key: 1,
    id: 1,
    name: "OddsChecker",
    referral_code: "2 Codes",
    total_owed: 3200,
    average_users_ltv: 200,
    total_ftds: 6000,
    average_deposit: 250,
    expandable: true,
    referral_codes: [
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 1",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 2",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
    ],
  },
  {
    key: 2,
    id: 2,
    name: "Action Network",
    referral_code: "2 Codes",
    total_owed: 5000,
    average_users_ltv: 300,
    total_ftds: 8000,
    average_deposit: 350,
    referral_codes: [
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 3",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 4",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
    ],
  },
  {
    key: 3,
    id: 3,
    name: "Barstool Sports",
    referral_code: "CODE789",
    total_owed: 10000,
    average_users_ltv: 500,
    total_ftds: 12000,
    average_deposit: 600,
  },
  {
    key: 4,
    id: 4,
    name: "Ralph Edwards",
    referral_code: "CODE101112",
    total_owed: 15000,
    average_users_ltv: 700,
    total_ftds: 20000,
    average_deposit: 800,
  },
  {
    key: 5,
    id: 5,
    name: "BetQL",
    referral_code: "2 Codes",
    total_owed: 20000,
    average_users_ltv: 1000,
    total_ftds: 25000,
    average_deposit: 1200,
    referral_codes: [
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 5",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
      {
        key: 1,
        id: null,
        name: "",
        referral_code: "CODE 6",
        total_owed: 3200,
        average_users_ltv: 200,
        total_ftds: 6000,
        average_deposit: 250,
      },
    ],
  },
  {
    key: 6,
    id: 6,
    name: "Rotoworld",
    referral_code: "CODE161718",
    total_owed: 25000,
    average_users_ltv: 1200,
    total_ftds: 30000,
    average_deposit: 1400,
  },
  {
    key: 7,
    id: 7,
    name: "BETMGM",
    referral_code: "CODE192021",
    total_owed: 30000,
    average_users_ltv: 1500,
    total_ftds: 35000,
    average_deposit: 160,
  },
  {
    key: 8,
    id: 8,
    name: "BED365",
    referral_code: "CODE222324",
    total_owed: 35000,
    average_users_ltv: 1700,
    total_ftds: 40000,
    average_deposit: 180,
  },
  {
    key: 9,
    id: 9,
    name: "BETFRED",
    referral_code: "CODE252627",
    total_owed: 40000,
    average_users_ltv: 2000,
    total_ftds: 45000,
    average_deposit: 200,
  },
  {
    key: 10,
    id: 10,
    name: "BETFAIR",
    referral_code: "CODE282930",
    total_owed: 45000,
    average_users_ltv: 2200,
    total_ftds: 50000,
    average_deposit: 220,
  },
  {
    key: 11,
    id: 11,
    name: "BETWAY",
    referral_code: "CODE313233",
    total_owed: 50000,
    average_users_ltv: 2500,
    total_ftds: 55000,
    average_deposit: 240,
  },
  {
    key: 12,
    id: 12,
    name: "BETVICTOR",
    referral_code: "CODE343536",
    total_owed: 55000,
    average_users_ltv: 2700,
    total_ftds: 60000,
    average_deposit: 260,
  },
  {
    key: 13,
    id: 13,
    name: "BETFAIR2",
    referral_code: "CODE373839",
    total_owed: 60000,
    average_users_ltv: 3000,
    total_ftds: 65000,
    average_deposit: 280,
  },
  {
    key: 14,
    id: 14,
    name: "BettingPros",
    referral_code: "CODE404142",
    total_owed: 65000,
    average_users_ltv: 3200,
    total_ftds: 70000,
    average_deposit: 300,
  },
  {
    key: 15,
    id: 15,
    name: "Arlene McCoy",
    referral_code: "CODE434445",
    total_owed: 70000,
    average_users_ltv: 3500,
    total_ftds: 75000,
    average_deposit: 320,
  },
];

const ExpandableRowTable = () => {
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  const paginatedData = data.slice(startIndex, endIndex);

  const handleExpandRow = (referralCode) => {
    console.log("referralCode", referralCode);
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(referralCode)) {
        newSet.delete(referralCode);
      } else {
        newSet.add(referralCode);
      }
      return newSet;
    });
  };

  const handlePaginationChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  return (
    <>
      <table className="sorting-table">
        <thead>
          <tr className="sorting-table-header-row">
            {columns.map((column) => {
              return (
                <th className="sorting-table-header-cell">
                  <div className="sorting-table-header-cell-content">
                    <span>{column.title}</span>
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/cd32e60c936c289aaadc4ebec51cb61d5c2e0422e2b12c7e1eccef3165d835e4?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200"
                      alt="Sort"
                      className="sortIcon"
                    />
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((category) => (
            <>
              <tr key={category.id} className="category-row">
                {columns.map((column, index) => (
                  <td className="category-row__cell" key={index}>
                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 30,
                      }}
                    >
                      {(column.dataIndex === "total_owed" ||
                        column.dataIndex === "average_users_ltv" ||
                        column.dataIndex === "total_ftds" ||
                        column.dataIndex === "average_deposit") &&
                        "$"}
                      {column.dataIndex === "total_owed" ||
                      column.dataIndex === "average_users_ltv" ||
                      column.dataIndex === "total_ftds" ||
                      column.dataIndex === "average_deposit"
                        ? formatNumber(category[column.dataIndex])
                        : category[column.dataIndex]}
                      {category.referral_codes &&
                        column.dataIndex === "referral_code" && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => handleExpandRow(category.id)}
                          >
                            {expandedRows.has(category.id) ? (
                              <DownOutlined />
                            ) : (
                              <UpOutlined />
                            )}
                          </span>
                        )}
                    </p>
                  </td>
                ))}
              </tr>
              {expandedRows.has(category.id) &&
                category.referral_codes.map((referral) => (
                  <tr key={referral.id} className="category-row expanded">
                    {columns.map((column, index) => (
                      <td className="category-row__cell" key={index}>
                        {(column.dataIndex === "total_owed" ||
                          column.dataIndex === "average_users_ltv" ||
                          column.dataIndex === "total_ftds" ||
                          column.dataIndex === "average_deposit") &&
                          "$"}
                        {column.dataIndex === "total_owed" ||
                        column.dataIndex === "average_users_ltv" ||
                        column.dataIndex === "total_ftds" ||
                        column.dataIndex === "average_deposit"
                          ? formatNumber(referral[column.dataIndex])
                          : referral[column.dataIndex]}
                      </td>
                    ))}
                  </tr>
                ))}
            </>
          ))}
        </tbody>
      </table>
      <div className="pagination">
        <Pagination
          current={currentPage}
          total={data.length}
          pageSize={pageSize}
          showSizeChanger
          onChange={handlePaginationChange}
        />
      </div>
    </>
  );
};
export default ExpandableRowTable;
